var _ = require('underscore');
var $ = require('jquery');
var TorsoView = require('backbone-torso/modules/View');
var questionnaireWidgetTemplate = require('./questionnaireWidgetTemplate.hbs');
var questionnaireContentTemplate = require('./questionnaireContentTemplate.hbs');
var applicationUtils = require('./../applicationUtils');
var launcherAppInterface = require('./../launcherApplicationInterface');
var DescriptiveTextQuestionView = require('./DescriptiveTextQuestionView');
var PortalSurveyResponseModel = require('./PortalSurveyResponseModel');
var urls = require('./../urls');
var asideView = require('./../aside/asideView');
var WizardWidget = require('./../wizard/WizardWidget');
var AppointmentDataBehavior = require('./../appointment/AppointmentDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel.js');

require('./../../target/node_modules/vecna-javascript/jquery-ui');
require('./../../target/node_modules/vecna-javascript/jquery.pluginMaker');
require('./../../target/node_modules/vecna-javascript/charLimiter');
require('./surveyItemRules');
require('jquery-migrate');
require('./../../target/node_modules/vecna-javascript/struts/template/js/plugins/jquery.subscribe');
require('./../../target/node_modules/vecna-javascript/struts/template/js/struts2/jquery.struts2');

// /** START FROM STRUTS HEADER TAG <s:head/> IN LAYOUT.JSP **/
$.scriptPath = '/' + applicationUtils.currentApplication.context + '/struts/';
$.struts2_jquery.version = '3.7.1';
// Trick struts into think the widget script is already loaded - this functionality is built into core jquery now.
$.struts2_jquery.scriptCache['js/base/widget.min.js?s2j=' + $.struts2_jquery.version] = true;
require('./../../target/node_modules/vecna-javascript/struts/template/js/struts2/jquery.ui.struts2');
// Required here to make sure the correct version of the datepicker is loaded.
$.struts2_jquery_ui.initDatepicker(false);
// /** END FROM STRUTS HEADER TAG <s:head/> IN LAYOUT.JSP **/

require('./../../target/node_modules/vecna-javascript/jquery.brecfast-radio');
require('./../../target/node_modules/vecna-javascript/picker');
require('./../../target/node_modules/vecna-javascript/pickamoment');
require('./../../target/node_modules/vecna-javascript/picker.date');
require('./../../target/node_modules/vecna-javascript/jquery.print');

var SURVEY_PAGE_TYPE = {
  FIRST_PAGE: 'firstSurveyPage',
  EMPTY_FIRST_PAGE: 'firstEmptyPage',
  AFTER_FIRST_PAGE: 'followingSurveyPage',
  FINISHED_PAGE: 'finishedSurveyPage',
  SUMMARY_PAGE: 'summarySurveyPage'
};

/**
 * This was copied from copied things and the reason for this is lost to history.  I don't know why it is needed.
 * @method _patchStruts2Div
 * @param struts2_jquery {jQuery.struts2_jquery} the struts2 jquery instance to patch.
 *   @param struts2_jquery.div {function} the div function to override.
 *   @param struts2_jquery.container {function} the container function use instead of the div method.
 * @private
 */
function patchStruts2Div(struts2_jquery) {
  struts2_jquery.div = function(el, o) {
    struts2_jquery.container(el, o);
  };
}

patchStruts2Div($.struts2_jquery);

/**
 * Widget to display a Questionnaire adapted specifically to display the questionnaire in the context of a pre-reg wizard.
 *
 *
 * @class QuestionnaireWidget
 * @constructor
 * @param options {Object}
 *   @param options.patientVecnaId {String} the patient id of the patient to get the questionnaires for.
 *   @param options.appointmentExternalId {String} the external vecna id of the patient to get the questionnaires for.
 *   @param options.questionnaireName {String} the name of the questionnaire to display.
 *   @param [options.readOnly=false] {Boolean} true if the view should be read-only, false otherwise.
 */
module.exports = TorsoView.extend({
  template: questionnaireWidgetTemplate,

  behaviors: {
    appointment: {
      behavior: AppointmentDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: {property: 'view:appointmentExternalId'}
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointment.data:externalAppointment.type'}
    }
  },

  /**
   * @return {String} the display name of this survey.
   */
  getQuestionnaireDisplayName: function() {
    return this._preRegSurveyConfiguration.get('displayName');
  },

  prepareFields: {
    preRegSurveyConfiguration: '_preRegSurveyConfiguration',
    isMultiAppointment: function() {
      return this.get('regDate');
    },
    appointmentTimeReplacement: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      return appointmentTypeModel && appointmentTypeModel.getEffectiveAppointmentTimeReplacement();
    },
    removeAppointmentTimeDisplay: function() {
      if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
        return false;
      }
      return appointmentConfigurationModel.get('removeAppointmentTimeDisplay');
    }
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the patient id of the patient to get the questionnaires for.
   *   @param options.appointmentExternalId {String} the external vecna id of the patient to get the questionnaires for.
   *   @param options.questionnaireName {String} the name of the questionnaire to display.
   *   @param [options.readOnly=false] {Boolean} true if the view should be read-only, false otherwise.
   * @override
   */
  initialize: function(options) {
    _.bindAll(this, '_navigateToNextSurveyPage', '_navigateToPreviousSurveyPage', '_submitPortalSubmitForm',
      '_ignoreEnter', '_initializeLoadedSurvey', '_setPrimaryActionDisable', '_printSurveyContent',
      '_clearLoadingMessage', '_loadSurvey', '_validateRulesBeforeSurvey');
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();
    this.set('patientVecnaId', options.patientVecnaId);
    this.set('appointmentExternalId', options.appointmentExternalId);
    var questionnaireName = options.questionnaireName;
    this.set('questionnaireName', questionnaireName);
    this.set('regDate', options.regDate);
    this.set('readOnly', options.readOnly);

    if (!options.readOnly) {
      var wizardWidget = this._getWizardWidget();
      wizardWidget.setNextQuestionnairePageAction(questionnaireName, this._navigateToNextSurveyPage);
      wizardWidget.setPreviousQuestionnairePageAction(questionnaireName, this._navigateToPreviousSurveyPage);
    }

    this.set('surveysAreSkipped', !questionnaireName);
    if (questionnaireName) {
      this._preRegSurveyConfiguration = new PortalSurveyResponseModel({
        appointmentExternalId: this.get('appointmentExternalId'),
        surveyName: questionnaireName
      });
      this.listenTo(this._preRegSurveyConfiguration, 'change:description', this._updateAside);

      this._preRegSurveyConfiguration.fetch()
        .then(this._validateRulesBeforeSurvey);
    }

    this._torsoViews = {};

  },

  /**
   * If the rules before the survey have not passed, then continue navigating forward or backward.
   * Else, render and load the survey
   * @method _validateRulesBeforeSurvey
   * @private
   */
  _validateRulesBeforeSurvey: function() {
    if (!this._preRegSurveyConfiguration.get('rulesBeforeSurveyPassed')) {
      this._getWizardWidget().continueNavigation();
    } else {
      this.render();
      this._loadSurvey();
    }
  },

  prerender: function() {
    if (this._surveyContentContainer) {
      // destroy the toggleRadio widget if it has been applied to the view
      if (this.$el.hasClass('toggleRadio')) {
        this.$el.toggleRadio('destroy');
      }
      this._surveyContentContainer.detach();
    }
  },


  postrender: function() {
    if (this._surveyContentContainer) {
      this.$el.find('[data-survey-content-container]').replaceWith(this._surveyContentContainer);
      this._initializeSurveyPage();
    }
  },

  /**
   * Load the survey content asynchronously into #surveyContent
   * Executes javascript code from layout.jsp and survey.tag
   *
   * @method _loadSurvey
   * @override
   */
  _loadSurvey: function() {
    /** START FROM SURVEY.TAG **/
    // Prevent jquery.ui.widget and datepicker from loading twice (manually added)
    $.struts2_jquery.loadAtOnce = true;

    // Load the survey content asynchronously
    this._surveyContentContainer = $(questionnaireContentTemplate());
    $.struts2_jquery.bind(this._surveyContentContainer.find('#surveyContent'), {
      jqueryaction: 'container',
      id: 'surveyContent',
      onsuc: 'initializeLoadedSurvey',
      onerr: 'errorState',
      href: this._getSurveyContentUrl(),
      hrefparameter: this._getSurveyContentUrlParameters()
    });
  },

  /**
   * @method _getSurveyContentUrl
   * @return {String} the url to retrieve the survey html from.
   * @private
   */
  _getSurveyContentUrl: function() {
    if (this._preRegSurveyConfiguration.isAnonymous()) {
      return '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/anonymous.do';
    }
    return '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/registeredUser.do';
  },

  /**
   * @method _getSurveyContentUrlParameters
   * @return {Object} parameters to pass to the survey content url defined by _getSurveyContentUrl().
   * @private
   */
  _getSurveyContentUrlParameters: function() {
    return $.param({
      recipientCode: this._preRegSurveyConfiguration.get('recipientCode'),
      surveyDefinitionId: this._preRegSurveyConfiguration.get('id'), // we want the id attribute, not this._preRegSurveyConfiguration.id
      surveyResponseId: this._preRegSurveyConfiguration.get('surveyResponseId'),
      appointmentStringId: this._preRegSurveyConfiguration.get('appointmentId') // Note: This should be the appointment id and not the external id
    });
  },

  /**
   * Highlight any error messages displayed on the survey questions.
   * Adds the '.error' class to the error messages and the corresponding questions.
   * @method _highlightSurveyQuestionErrors
   * @private
   */
  _highlightSurveyQuestionErrors: function() {
    var $errorMessages = this.$el.find('span.errorMessage');
    $errorMessages.addClass('error');
    $errorMessages.parent().siblings('.label').addClass('error');
  },

  /**
   * @method _attached
   * @private
   */
  _attached: function() {
    if (!this.get('readOnly')) {
      this.listenTo(this._getWizardWidget(), 'print', this._printSurveyContent);
    }
    this._bindIgnoreEnterToWindow();
    var $surveyContent = $('#surveyContent');
    /**
     * If the survey loading fails, display an error message
     */
    $.destroyTopic('errorState'); // destroy the topic and unsubscribe all subscribers
    $.subscribe('errorState', function() {
      $surveyContent.html($.i18n.prop('error.survey'));
    });
    /**
     * All survey pages are wrapped in a "insertedSurvey" tag (see surveyLayout.jsp) - we want to wait until it is loaded
     * so that we know when to overwrite the survey buttons with our own, and initialize the necessary components
     */
    $.destroyTopic('initializeLoadedSurvey');
    $.subscribe('initializeLoadedSurvey', this._initializeLoadedSurvey);
  },

  /**
   * Do some cleanup when the view is detached.
   * @method _detached
   * @private
   * @override
   */
  _detached: function() {
    $.destroyTopic('errorState');
    $.destroyTopic('initializeLoadedSurvey');

    if (this.$el.hasClass('toggleRadio')) {
      this.$el.toggleRadio('destroy');
    }
    this._unbindIgnoreEnterToWindow();
    if (!this.get('readOnly')) {
      this.stopListening(this._getWizardWidget(), 'print', this._printSurveyContent);
    }
  },

  /**
   * Do some cleanup when the view is disposed.
   * @method _dispose
   * @private
   * @override
   */
  _dispose: function() {
    this._unbindIgnoreEnterToWindow();
  },

  /**
   * Gets the wizard widget for the patient and appointment.
   * @method _getWizardWidget
   * @return {WizardWidget} the wizard widget for the patient and appointment.
   * @private
   */
  _getWizardWidget: function() {
    return WizardWidget.getWizardWidget({
      patientVecnaId: this.get('patientVecnaId'),
      appointmentExternalId: this.get('appointmentExternalId'),
      regDate: this.get('regDate')
    });
  },

  /**
   * Binds the ignore enter method to the keydown event on the window object.
   * @method _bindIgnoreEnterToWindow
   * @private
   */
  _bindIgnoreEnterToWindow: function() {
    this._unbindIgnoreEnterToWindow();
    $(window).on('keydown', this._ignoreEnter);
  },

  /**
   * Unbinds the ignore enter method on the keydown event on the window object.
   * @method _unbindIgnoreEnterToWindow
   * @private
   */
  _unbindIgnoreEnterToWindow: function() {
    $(window).off('keydown', this._ignoreEnter);
  },

  /**
   * Ignore the enter event to prevent survey forms from submitting.
   * @method _ignoreEnter
   * @param event {jQuery.Event} the jquery event to test.
   * @return {Boolean} explicity false to prevent propagation if the keycode matches, undefined otherwise.
   * @private
   */
  _ignoreEnter: function(event) {
    if (event && event.keyCode === 13) {
      event.preventDefault();
      return false;
    }
  },

  /********** The following functions are adapted from survey.tag **********/
  /**
   * Actually prints just the survey contents.
   * @method _printSurveyContent
   * @private
   */
  _printSurveyContent: function() {
    this.$el.find('#surveyContent').print();
  },

  /**
   * Navigates to the next page of the survey based on the state of the current page.
   * @method _navigateToNextSurveyPage
   * @private
   * @return {promise} a promise that will resolve when the survey is submitted, or that
   * is rejected if the survey will not be submitted
   */
  _navigateToNextSurveyPage: function() {
    this._setPrimaryActionDisable();
    var surveyPageType = this.get('surveyPageType');
    if (this.get('surveysAreSkipped') || surveyPageType === SURVEY_PAGE_TYPE.SUMMARY_PAGE) {
      return this._submitSurvey();
    } else if (surveyPageType === SURVEY_PAGE_TYPE.FIRST_PAGE || surveyPageType === SURVEY_PAGE_TYPE.AFTER_FIRST_PAGE) {
      var nextSurveyPageUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/nextPage.do';
      if (this._preRegSurveyConfiguration.isAnonymous()) {
        nextSurveyPageUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/anonymous_nextPage.do';
      }
      return this._navigateToSurveyPage(nextSurveyPageUrl);
    } else {
      return this._submitPortalSubmitForm();
    }
  },

  /**
   * Perform the logic to submit the completed survey.
   * @method _submitSurvey
   * @return {Boolean} return false to prevent event propagation.
   * @private
   */
  _submitSurvey: function() {
    this._displayProcessingMessage();

    if (this.get('surveysAreSkipped')) {
      this._getWizardWidget().navigateToNextStep();
    } else {
      var submitUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/submit.do';

      if (this._preRegSurveyConfiguration.isAnonymous()) {
        submitUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/anonymous_submit.do';
      }

      return $.post(submitUrl, this.$el.find('#surveyForm').serializeArray())
        .then(this._submitPortalSubmitForm);
    }
  },

  /**
   * Default implementation for submitting the #portalSubmitForm in survey.tag
   * Override this function to execute some alternative code after completing a survey.
   * @method _submitPortalSubmitForm
   * @private
   */
  _submitPortalSubmitForm: function() {
    if (this._preRegSurveyConfiguration.get('rulesBeforeSurveyPassed')) {
      return this._preRegSurveyConfiguration.save();
    }
    return $.Deferred().resolve().promise();
  },

  /**
   * Navigates to the previous page of the survey.
   * @method _navigateToPreviousSurveyPage
   * @private
   * @return {promise} a promise that will be resolved if the wizard should navigate to the previous page
   */
  _navigateToPreviousSurveyPage: function() {
    this._setPrimaryActionDisable();
    var surveyPageType = this.get('surveyPageType');
    var previousSurveyPageUrl;
    if (surveyPageType === SURVEY_PAGE_TYPE.AFTER_FIRST_PAGE) {
      previousSurveyPageUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/backPage.do';
      if (this._preRegSurveyConfiguration.isAnonymous()) {
        previousSurveyPageUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/anonymous_backPage.do';
      }
      return this._navigateToSurveyPage(previousSurveyPageUrl);
    } else if (surveyPageType === SURVEY_PAGE_TYPE.SUMMARY_PAGE) {
      previousSurveyPageUrl = '/' + applicationUtils.APPLICATIONS.PATIENT_PORTAL.context + '/survey/back.do';
      return this._navigateToSurveyPage(previousSurveyPageUrl);
    }
    return $.Deferred().resolve().promise();
  },

  /**
   * Navigates to the given survey page (forward or back).
   * @method _navigateToSurveyPage
   * @param followingUrl {String} the url to get the contents of the survey page.
   * @return {promise} a rejected promise
   * @private
   */
  _navigateToSurveyPage: function(followingUrl) {
    var view = this;
    var ajaxParams = {
      url: followingUrl,
      data: view.$el.find('#surveyForm').serializeArray(),
      cache: false,
      method: 'POST'
    };
    $.ajax(ajaxParams).done(function(msg) {
      view._scrollToTop();
      view.$el.find('#surveyContent').html(msg);
      view._surveyPageCallback();
      view.delegateEvents();
    });
    return $.Deferred().reject().promise();
  },

  /**
   * Continue navigation if the current survey page is an empty page
   * Clear the loading message if current page is not empty
   *
   * @method _continueNavigationIfEmpty
   * @private
   */
  _continueNavigationIfEmpty: function() {
    var wizardWidget = this._getWizardWidget();
    wizardWidget.hidePrintButton();

    var skipFinishedPage = this.$el.find('#skipFinishedPage').text() === 'true';
    this.set('skipFinishedPage', skipFinishedPage);

    var $surveyPageType = this.$el.find('#surveyPageType');
    var surveyPageTypeValue = $surveyPageType.val();
    this.set('surveyPageType', surveyPageTypeValue);

    var surveyPageInternallyBlank = false;
    if (surveyPageTypeValue === SURVEY_PAGE_TYPE.SUMMARY_PAGE) {
      this._setUpPrintButton();
      surveyPageInternallyBlank = this.$el.find('#questions').children('.question-yn:visible').length <= 0;
    } else {
      surveyPageInternallyBlank = this.$el.find('#surveyForm').children('.surveyItem:visible').length <= 0;
    }

    var surveyPageIsEmptyFirstPage = surveyPageTypeValue === SURVEY_PAGE_TYPE.EMPTY_FIRST_PAGE;
    var surveyPageIsEmpty = surveyPageIsEmptyFirstPage || surveyPageInternallyBlank;

    if (surveyPageIsEmpty || skipFinishedPage) {
      this._displayProcessingMessage();
      wizardWidget.continueNavigation();
    } else {
      this._clearLoadingMessage();
    }
  },

  /**
   * Initialization function used by survey, to attach and customize any extra components
   * @method _initializeSurveyPage
   * @private
   */
  _initializeSurveyPage: function() {
    // This is used as a workaround to using a class to initially hide the elements.  But the class will prevent jQuery from being
    // able to show the element through animation.  So we need to remove the class and have jQuery manage show/hide.
    // Operation: Remove the class and hide the element with jQuery and then the animation effects will work.
    // Classes are used to initially hide the elements because inline styles are not permitted by our CSP.
    this.$el.find('.brec-hidden')
      .hide()
      .removeClass('brec-hidden');

    this.$el.find('.limitedTextArea')
      .charLimiter({
        'hideLimit': 'true',
        'cutoff': this.$el.find('#cutoff').text(),
        'warningLimit': this.$el.find('#warningLimit').text()
      });

    if (!this.get('readOnly')) {
      this.$el.find('.questionInput')
        .surveyItemRuleListener({
          pageId: this.$el.find('#pageId').text(),
          base_url: '/patient-portal',
          enablePrimaryActionPane: this._clearLoadingMessage,
          disablePrimaryActionPane: this._setPrimaryActionDisable
        });
    }

    this.$el.find('.warning')
      .css('font-weight', 'normal');

    var $actionError = this.$el.find('.actionError');
    if ($actionError.children().length > 0) {
      $actionError.addClass('ui-state-error ui-corner-all');
    }

    var visibleMultiSelects = this.$el.find('.multiselect').filter(':visible');
    visibleMultiSelects.each(function() {
      var $this = $(this);
      if ($this.height() < 100) {
        $this.css('height', '200px');
      }
      $this.multiselect({show: 'show'});
    });


    this.$el.find('.survey-edit').append($('<img/>').attr('src', urls.staticImageService + 'edit-icon'));

    var view = this;
    /*
     * Sets timeout and allows page to be rendered before the hidden radio buttons and checkboxes are styled
     */
    setTimeout(function() {
      view.$el.find('.radio').filter(':hidden').buttonset();
      view.$el.find('.checkbox').filter(':hidden').buttonset();
    }, 1);

    /** NEW UI RADIO/CHECKBOX STYLING **/
    // Destroy the plugin and re-initialize as the plugin's init checks for all radio buttons/checkboxes on the page
    // during the init method. When the same instance of the view is used to switch from review to edit modes, the
    // init of the plugin happens when the page is in read-only mode, and hence there will be no radio buttons/checkboxes.
    // Destroying the plugin and re-initializing always checks for the latest mode of the page.
    this.$el.toggleRadio('destroy');
    this.$el.toggleRadio();
    this.$el.findAll(':checked').addClass('checked');

    this._removeOldDescriptiveTextQuestionViews();
    $.ajax(urls.surveyLanguage, {dataType: 'text'}).then(function(languageKey) {
      view.$el.find('[inject=survey-item-descriptive-text]').each(function() {
        var $this = $(this);
        var surveyItemId = parseInt($this.attr('survey-item-id'), 10);
        var $multimedia = $this.siblings('img, video');
        $multimedia.remove();
        var descriptiveTextQuestionView = new DescriptiveTextQuestionView({
          surveyItemId: surveyItemId,
          languageKey: languageKey,
          $multimedia: $multimedia
        });

        view._renderDescriptiveTextQuestionView($this, descriptiveTextQuestionView);
      });
    });

    this.delegateEvents();
  },

  /**
   * If not in read-only mode, then clear loading message.
   * @method _clearLoadingMessage
   * @private
   */
  _clearLoadingMessage: function() {
    if (!this.get('readOnly')) {
      this._getWizardWidget().clearLoadingMessage();
    }
  },

  /**
   * If not in read-only mode, then clear loading message.
   * @method _setLoadingMessage
   * @param loadingMessageText {String} the text to display as the loading message.
   * @private
   */
  _setLoadingMessage: function(loadingMessageText) {
    if (!this.get('readOnly')) {
      this._getWizardWidget().setLoadingMessage(loadingMessageText);
    }
  },

  /**
   * Registers the child view if not already done so, then calls view.attachTo with the element argument
   *
   * @method _renderDescriptiveTextQuestionView
   * @private
   * @param $el {jQuery element} the element to attach to.
   * @param view {View} the Torso view
   */
  _renderDescriptiveTextQuestionView: function($el, view) {
    this.registerTrackedView(view);
    view.detach();
    this._torsoViews[view.cid] = view;
    view.attachTo($el);
  },

  /**
   * Remove the old question views from a previous render and dispose.
   * @method _removeOldDescriptiveTextQuestionViews
   * @private
   */
  _removeOldDescriptiveTextQuestionViews: function() {
    _.each(this._torsoViews, function(descriptiveTextQuestionView) {
      this.unregisterTrackedView(descriptiveTextQuestionView);
      descriptiveTextQuestionView.dispose();
    }, this);
    this._torsoViews = {};
  },

  /**
   * Cleans up the page after the submit button is pressed. It hides the submission buttons, clears
   * the survey content, displays a loading message, and scrolls the page up
   * @method _displayProcessingMessage
   * @private
   */
  _displayProcessingMessage: function() {
    this._scrollToTop();
    this.$el.find('#surveyContent').html('');
    this._setLoadingMessage($.i18n.prop('wizard.buttons.loading'));
  },

  /**
   * Show the print button when at home and printable version enabled
   *
   * @method _setUpPrintButton
   * @private
   */
  _setUpPrintButton: function() {
    var wizardWidget = this._getWizardWidget();
    if (launcherAppInterface.isAtHospital()) {
      // using locked down tablet at hospital
      wizardWidget.hidePrintButton();
    } else if (this.$el.find('#enablePrintableVersion') && this.$el.find('#enablePrintableVersion').val() !== 'true') {
      // printable version not enabled
      wizardWidget.hidePrintButton();
    } else {
      wizardWidget.showPrintButton();
    }
  },

  /**
   * Survey page callback function.
   * @method _surveyPageCallback
   * @private
   */
  _surveyPageCallback: function() {
    // destroy the toggleRadio widget if it has been applied to the view
    if (this.$el.hasClass('toggleRadio')) {
      this.$el.toggleRadio('destroy');
    }

    this._initializeSurveyPage();
    this._continueNavigationIfEmpty();
    this._highlightSurveyQuestionErrors();
  },

  /**
   * All survey pages are wrapped in a 'insertedSurvey' tag (see surveyLayout.jsp) - we want to wait until it is loaded
   * so that we know when to overwrite the survey buttons with our own, and initialize the necessary components
   * @method _initializeLoadedSurvey
   * @private
   */
  _initializeLoadedSurvey: function() {
    var view = this;
    this.render();
    this.$el.find('#surveyContent').children().each(function() {
      if ($(this).is('INSERTEDSURVEY')) {
        view._continueNavigationIfEmpty();
      }
    });
  },
  /********** End functions adapted from survey.tag **********/

  /********** The following functions are adapted from layout.jsp **********/
  /**
   * Disable the #primary-action form buttons and add a loading animation to the section
   * @method _setPrimaryActionDisable
   * @private
   */
  _setPrimaryActionDisable: function() {
    var loadingMessage = this.$el.find('#loaderIndicatorText').attr('value');
    this._setLoadingMessage(loadingMessage);
  },
  /********** End functions adapted from layout.jsp **********/

  /**
   * Fix for PSS-4875. window.scrollTo(0,0) doesn't work if both head and body have height 100%
   * and overflow: auto
   * @method _scrollToTop
   * @private
   */
  _scrollToTop: function() {
    var topNav = $('.topnav').get(0);
    if (topNav) {
      topNav.scrollIntoView();
    }
  },

  /**
   * Update the aside to display the description.
   * @method _updateAside
   * @private
   */
  _updateAside: function() {
    if (this.get('readOnly')) {
      return;
    }
    var asideOptions = {
      asideHeaderMessageKey: 'aside.information.header'
    };
    var surveyAsideText = this._preRegSurveyConfiguration.get('description');
    if (surveyAsideText) {
      asideOptions.asideText = surveyAsideText;
    } else if (launcherAppInterface.isAtHospital()) {
      asideOptions.asideContentMessageKey = 'prereg.surveys.aside.ereg';
    } else {
      asideOptions.asideContentMessageKey = 'prereg.surveys.aside';
    }
    asideView.updateAsideContent(asideOptions);
  }
});
